import { InsertedPrefix, TextMentionStorage } from '../../../../../../../common/tiptap/extensions/mention/TextMention';
import { useActiveTiptapEditorCallback } from '../../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

const useInsertMentionAction = () => {
    return useActiveTiptapEditorCallback((editor) => {
        if (!editor?.isEditable) return false;

        const { from } = editor.state.selection;
        const previousCharacter = from > 0 ? editor.state.doc.textBetween(from - 1, from, '') : '';
        const needsLeadingSpace = !!previousCharacter && !/\s/.test(previousCharacter);
        const insertCharacter: InsertedPrefix = needsLeadingSpace ? ' @' : '@';

        const mentionStorage = editor.storage.textMention as TextMentionStorage;
        mentionStorage.popupInsertedPrefix = insertCharacter;

        const success = editor.chain().focus().insertContent(insertCharacter).run();

        queueMicrotask(() => {
            if (mentionStorage?.popupInsertedPrefix === insertCharacter) mentionStorage.popupInsertedPrefix = '';
        });
        return success;
    }, []);
};

export default useInsertMentionAction;
